import { FC, SVGProps } from 'react'
import { ReactComponent as AIListeningIcon } from 'src/assets/svg/ai-Listening.svg'
import { ReactComponent as AdAnalysisIcon } from 'src/App/AppRouter/Layout/Sidebar/icons/Ad-Analysis.svg'
import { ReactComponent as ContentAnalysisIcon } from 'src/App/AppRouter/Layout/Sidebar/icons/Content-Analysis.svg'
import { ReactComponent as InboxAnalysisIcon } from 'src/App/AppRouter/Layout/Sidebar/icons/Inbox-Analysis.svg'
import { ReactComponent as ReviewAnalysisIcon } from 'src/App/AppRouter/Layout/Sidebar/icons/Review-Analysis.svg'
import { ReactComponent as SocialListeningIcon } from 'src/App/AppRouter/Layout/Sidebar/icons/Social-Listening.svg'
import { ReportModule } from '../interfaces/report.interface'

export interface ModuleMeta {
  // Pill background. Each is the module's accent at 10% so the pill stays light.
  background: string
  color: string
  icon: FC<SVGProps<SVGSVGElement>>
  label: string
}

// Only the Inbox Analysis colours are confirmed from the spec (#BA993E1A
// background). The rest are read off the Figma screenshot and are best guesses
// until the real values are supplied — swap them here, nothing else references
// these hexes.
export const MODULE_META: Record<ReportModule, ModuleMeta> = {
  ad: {
    background: '#A855C71A',
    color: '#A855C7',
    icon: AdAnalysisIcon,
    label: 'Ad Analysis',
  },
  ai: {
    background: '#34A8531A',
    color: '#34A853',
    icon: AIListeningIcon,
    label: 'AI Listening',
  },
  content: {
    background: '#4A9CC41A',
    color: '#4A9CC4',
    icon: ContentAnalysisIcon,
    label: 'Content Analysis',
  },
  inbox: {
    background: '#BA993E1A',
    color: '#BA993E',
    icon: InboxAnalysisIcon,
    label: 'Inbox Analysis',
  },
  review: {
    background: '#3B4CB81A',
    color: '#3B4CB8',
    icon: ReviewAnalysisIcon,
    label: 'Review Analysis',
  },
  social: {
    background: '#8080FF1A',
    color: '#8080FF',
    icon: SocialListeningIcon,
    label: 'Social Listening',
  },
}
